import axios from 'axios';
import store from '../../store';

// STORY-011B: Add request interceptor to include customer context in headers
axios.interceptors.request.use(function (config) {
    // Add customer context to request headers if available
    const customerContext = store.getters['authentication/customerContext'];
    if (customerContext && customerContext.customer_id) {
        config.headers['X-Customer-ID'] = customerContext.customer_id;
        console.log(`🏢 Adding customer context to API request: ${customerContext.customer_id}`);
    }
    
    // Add user email for handoff sessions (for created_by_email field)
    const isHandoffSession = localStorage.getItem('handoff-session') === 'true';
    if (isHandoffSession) {
        const sessionData = localStorage.getItem('supabase-session');
        if (sessionData) {
            try {
                const session = JSON.parse(sessionData);
                if (session.user && session.user.email) {
                    config.headers['X-User-Email'] = session.user.email;
                    console.log(`📧 Adding user email to API request: ${session.user.email}`);
                }
            } catch (error) {
                console.error('Failed to parse session data for email:', error);
            }
        }
    } else {
        // For regular authenticated users, try to get email from authentication store
        const authState = store.state.authentication;
        if (authState.authenticationStatus && authState.userName) {
            // For regular users, userName might contain the email
            config.headers['X-User-Email'] = authState.userName;
            console.log(`📧 Adding user email to API request (regular auth): ${authState.userName}`);
        }
    }
    
    return config;
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data

    const headers = response.headers;

    // set pagination
    store.dispatch('pagination/setPagination', headers);

    return response;
}, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
});


export default axios;